import { modal } from 'react-modal-dom';

const MySmallModal = () => {
  return (
    <div className='modal-small'>
      <button type='button' onClick={modal.close}>
        Close modal
      </button>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum debitis
        repellat accusamus qui, error amet veniam eius sint quae autem facere
        architecto necessitatibus, libero ducimus eveniet reprehenderit odio
        odit ea!
      </p>
    </div>
  );
};

export default MySmallModal;
